export enum TechnicalMgntModuleApiSuffixModels {
    TECH_AREA_LIST = "tech-area",
    TECH_AREA_DETAILS = "tech-area/details",
    UX_DIVISIONS = 'ux/divisions',
    UX_DISTRICTS = 'ux/districts',
    UX_DISTRICTS_BY_USER = 'ux/district-by-user',
    UX_BRANCHES = 'ux/branches',
    UX_AREAS = 'ux/tech-area',
    UX_TECHNITIAN = 'ux/technitian',
    UX_TECHNICIAN = 'ux/technician',
    UX_INSPECTOR = 'ux/inspection-inspector',
    UX_WAREHOUSE = "ux/warehouses",
    UX_BOUNDRY = 'ux/usersdropdown',
    TECH_STOCK_ORDER = 'technician-stock-order',
    TECH_STOCK_ORDER_DETAILS = "technician-stock-order-details",
    INTTECH_TRANSFER = 'inttech-transfer',
    TECHNICIAN_ROLE = 'ux/technician/by-role',
    STOCK_ORDER_APPROVAL = 'technician-stock-order-approval',
    UX_LOCATIONS = 'ux/technician-storage-location',
    LOCATION_NAME = 'ux/technician/by-location',
    SKILL_MATRIX_CONFIG = 'skill-matrix-config',
    SYSTEM_TYPE_SUB_CATEGORY = 'system-type-sub-category',
    SYSTEM_TYPE = 'system-type',
    SYSTEM_TYPE_ID = 'ux/system-type',
    UX_SYSTEM_TYPE = 'ux/system-type',
    UX_SYSTEM_TYPE_SUB_CATEGORY = 'ux/system-type-sub-category',
    UX_SYSTEM_TYPE_SUB_CATEGORIES = 'ux/system-type/sub-categories',
    SERVICE_SUB_TYPES_DETAILS = 'service-sub-types/details',
    SERVICE_SUB_TYPES = 'service-sub-types',
    FAULT_DESCRIPTION_CONFIG = 'fault-descriptions-config',
    UX_SERVICE_SUB_TYPES_AVAILABLE_ASSIGNED = 'ux/service-sub-types/available-assigned',
    FAULT_DESCRIPTION = 'fault-descriptions',
    FAULT_DESCRIPTION_SERVICE_SUB_TYPES = 'fault-descriptions/service-subtype',
    UX_SERVICE_SUB_TYPES = 'ux/service-sub-types',
    UX_SKILL_MATRIX_CONFIG_JOBTYPE = 'ux/skill-matrix-config/job-type',
    SKILL_MATRIX_CONFIG_JOBTYPE_SKILL_LEVEL = 'skill-matrix-config/job-type-skill-level',
    SKILL_MATRIX_CONFIG_SKILL_MAPPED_JOB_TYPES = 'skill-matrix-config/skill-mapped-job-types',
    JOBTYPE = 'ux/job-type',
    DEFAULT_COSUMABLE_CONFIGURATION = 'default-consumable-configuration',
    CONSUMABLE_CONFIGURATION_LIST_VIEW = 'consumable-configuration',
    TECHNICIAN_TYPES = 'ux/technician-types',
    TECHNICIAN_USER_TYPE_CONFIG = 'technician-user-type-config',
    USER_TYPES = 'ux/usertypes',
    TECHNICIAN_USER_TYPE_CONFIG_DETAILS = 'technician-user-type-config/details',
    DISPATCH_CONFIG_APPOINTMENT = 'dispatch-config/appointment',
    DISPATCH_CONFIG_EMPLOYEE = 'dispatch-config/employee',
    DISPATCH_CONFIG = 'dispatch-config',
    PANEL_TYPE_CONFIG = 'panel-type-config',
    UX_PANEL_TYPE_CONFIG = 'ux/panel-type-config',
    TECHNICIAN_STAFF_REGISTRATION = 'technician-staff-registration',
    TECHNICIAN_STAFF_REGISTRATION_DETAILS = 'technician-staff-registration/details',
    TECH_AREA_SEARCH = 'tech-area/search',
    TECH_STOCK_LOCATIONS_GET_TECH_STOCK_TECH_LOCATIONS = 'tech-stock-location/get-tech-stock-tech-locations',
    UX_TECHNICIAN_BY_ROLE = 'ux/technician/by-role',
    TECHNICIAN_USER_TYPE_CONFIG_SEARCH = 'technician-user-type-config/search',
    TECH_AREA_BOUNDARY = 'tech-area/boundary',
    WARRANTY_PERIOD_TECH_JOB_TYPES = 'ux/technician-job-types',
    CALL_CREATION_CONFIG = 'call-creation-config',
    CALL_CREATION_CONFIG_DETAILS = 'call-creation-config',
    APPOINTMENTS_TECHNICIAN_DETAILS = "appointments/technician-details",
    APPOINTMENTS_TECHNICIAN = "technical-appointments",
    BILL_OF_MATERIAL_DETAILS = "bill-of-material/bill-of-material-details",
    BILL_OF_MATERIAL_ITEM_DETAILS = "bill-of-material/bill-of-material-item-details",
    BILL_OF_MATERIAL = "bill-of-material",
    BILL_OF_MATERIAL_LABOUR_CHARGE = 'bill-of-material/service-labour-charge',
    INSTALLATION = "installation",
    BILL_OF_MATERIAL_SEARCH = "stock-balance/serial",
    BILL_OF_MATERIAL_SEARCH_BY_STOCK_CODE = "ux/items",
    STANDARD_TAX = 'tax/standard-tax',
    APPOINTMETS_NEXT_AVAILBLE = 'appointments-next-available',
    UX_DIAGNOSIS = 'ux/diagnosis',
    CALL_STATUS_REPORT = 'call-status-report',
    REFERTOR_TO_SALES_FLAG_TYPE = 'refertosales-flag-type',
    TECHNICAL_AREA_MANAGEMENT_WORKLIST = 'technical-work-list',
    COORDINATOR_REQUEST_DISTRICT_MANAGEMENT = 'coordinator/request/district-management',
    TECHNICAL_AREA_MANAGEMENT_WORKLIST_STATUS = 'ux/technical-work-list-status',
    UX_ORDERTYPES = 'ux/ordertypes',
    UX_RQNSTATUS = 'ux/rqnstatus',
    UX_TECHNICIAN_STOCK_ORDER_NUMBER = 'ux/technician-stock-order-number',
    REFERTOR_TO_SALES_FEEDBACK = 'referto-sales-feedback',
    CALL_INITIATION_STATUS = 'ux/call-initiation-status',
    CALL_INITIATION_CONTACT = 'call-initiation-contact',
    ONHOLD_STATUS_CONFIGURATION_DETAILS = 'onHold-status-config/details',
    ONHOLD_STATUS_CONFIGURATION = 'onHold-status-config',
    CALL_INITIATION_ON_HOLD = 'call-initiation-on-hold',
    CALL_INITIATION_VOID = 'call-initiation-void',
    CALL_INITIATION_ON_HOLD_VALIDATION = 'call-initiation-on-hold-validation',
    CALL_INITIATION_VOID_VALIDATION = 'call-initiation-void-validation',
    INSPECTION_VOID = 'inspection-void',
    CALL_INITIATION_DOCUMENTS = 'call-initiation-documents',
    TECHNICAL_API_BOUNDARIES = 'ux/boundaries',
    SERVICE_CALL_INITIATION_VALIDATION = 'service-call-initiation-validation',
    SERVICE_CALL_INITIATION_CUSTOMER = 'service-call-initiation-customer',
    CALL_INITIATION = 'call-initiation',
    CUSTOMER_TECHNICAL_DETAILS = 'customer-technical-details',
    SERVICE_CALL_INITIATION = 'service-call-initiation',
    SERVICE_CALL_INITIATION_QUESTIONS = 'service-call-initiation-questions',
    TECH_STOCK_LOCATION_TECH_STOCK_LOCATION_VALIDATE = 'tech-stock-location/tech-stock-location-validate',
    APPOINTMENTS_ACTUAL_TIMING = 'appointments-actual-timing',
    INSPECTION_APPOINTMENTS_ACTUAL_TIMING = 'inspection-actual-timing',
    UX_REFERTOSALES_FLAG_TYPE = 'ux/refer-to-sales-flag-type',
    UX_REFERTO_SALES_FEEDBACK = 'ux/referto-sales-feedback',
    STOCK_SWAP_DETAILS = 'stock-swap/details',
    STOCK_SWAP_OUT_DETAILS = 'stock-swap-out-details',
    STOCK_SWAP = 'stock-swap',
    STOCK_SWAP_APPROVAL = 'stock-swap-approval',
    BILL_OF_MATERIAL_UX = "ux/bill-of-material-action-status",
    UX_STOCK_SWAP_STATUS = "ux/Stock-Swap-Status",
    CAPACITY_APPOINTMETN_SLOT = "capacity-appointment-slots",
    UX_STOCK_SWAP_ITEMS = "ux/stock-swap-items",
    UX_JOB_ORDER_STATUS = 'ux/joborderstatus',


    STANDBY_ROSTER_TECHNICIAN_DETAILS = 'standby-roster-config/technician-user-types/details',
    STANDBY_ROSTER_TECHNICIAN_USER_TYPE = 'standby-roster-config/technician-user-types',
    STANDBY_ROSTER_STARTING_DAY_DETAILS = 'standby-roster-config/starting-days',
    UX_TECHNICIAN_ROLE = 'ux/escalation-role',
    STANDBY_ROSTER_TECHNICIAN = 'standby-roster-config/technician-user-types',
    UX_DAYS = 'ux/days',

    LIGHTNING_COVER_CONFIG = 'lightning-cover-config',
    LIGHTNING_COVER_STOCKID = 'ux/lightning-cover-config-stockid',
    LIGHTNING_COVER_LIGHTNING_FEE = 'ux/lightning-cover-config-lightning-fee',

    PR_CALL = 'pr-call',
    PR_CALL_APPROVAL = 'pr-call/approval',
    PR_CALL_ITEM_PRICE = 'pr-call/item-price',
    PR_CALL_EQUIPMENTS = 'pr-call/equipments',
    SERVICE_CALL_APPROVAL_STATUS = 'ux/service-call-approval-status',
    SPECIAL_PROJECT_TECHNICAL_COORDINATOR_LIST = 'special-project-technical-coordinator-details',
    PRICE_LIST = 'price-list',
    NKA_SERVICE_CALL = 'nka-service-call',
    NKA_SERVICE_CALL_OWNERSHIP = 'nka-service-call-ownership',
    NKA_SERVICE_CALL_RESUBMIT = 'nka-service-call-resubmit',
    NKA_SERVICE_CALL_DECLINE = 'nka-service-call-decline',
    EXEC_SERVICE_CALL = 'execuguard-service-call',
    EXEC_SERVICE_CALL_STATUS = 'ux/execu-guard-service-call-status',
    EXEC_SERVICE_CALL_APPROVAL = 'execuguard-service-call-approval',
    EXEC_SERVICE_CALL_DECLINE = 'execuguard-service-call-resubmit',
    PRICE_LIST_ID = 'ux/price-list',
    SAVE_OFFER = 'save-offer',
    SAVE_OFFER_APPROVAL = 'save-offer/approval',
    SAVE_OFFER_EQUIPMENTS = 'save-offer/equipments',

    STANDBY_ROSTER = 'standby-roster',
    STANDBY_ROSTER_TECHNICIAN_MANAGER_DETAILS = 'standby-roster-technician-manager-details',
    UX_TECHAREA = 'ux/techArea',
    TECHNICIAN_CUTOFF_CONFIG = 'technician-cutoff-config',

    INVOICING_AUTO_CONFIG_DETAILS = 'invoicing-auto-config-details',
    INVOICING_AUTO_CONFIG = 'invoicing-auto-config',
    SERVICE_CALL_INITIATION_QUICK_ADD = "service-call-initiation/quick-add",
    FAULT_DESCRIPTION_QUICK_CALL = 'ux/fault-descriptions',
    FAULT_DESCRIPTION_QUICK_CALL_SYSTEM_TYPE = 'ux/fault-descriptions/system-type',
    INSPECTION_SKILL_MATRIX_CONFIG_JOBTYPE = 'inspection-skill-matrix-config-jobtype',
    INSPECTION_SKILL_MATRIX_CONFIG = 'inspection-skill-matrix-config',
    REBOOK_CONFIG_DETAILS = 'rebook-config-details',
    REBOOK_CONFIG_CREATE = 'rebook-config',
    REBOOK_REASON = 'callinitiation-rebook',
    REBOOK_NOCHARGE = 'bill-of-material-nocharge',
    REBOOK_REASON_LIST = 'ux/callinitiation-rebook-reason',
    TECH_TRANSFER_LIST = 'tech-transfer/transferred-list-details',
    TECH_TRANSFER_PICKED_LIST = 'tech-transfer/packerlist-details',
    QUICK_CALL_ESCALATION = 'service-call-initiation/escalation',
    QUICK_CALL_ESCALATION_APPROVAL = 'service-call-initiation/escalation-approval',

    SPECIAL_PROJECT_TYPE_CONFIG = 'special-project-types',
    SPECIAL_PROEJCT_TYPE_DROPDOWN = 'ux/special-project-types',
    SPECIAL_PROJECT_LIST = 'special-project',
    SPECIAL_PROJECT__DETAILS = 'special-project-details',
    SPECIAL_PROJECT__TECHNITIAN_DETAILS = 'special-project-technician',

    SPECIAL_PROJECT_REGION_LIST = 'special-project/ux/region',
    SPECIAL_PROJECT_DIVISION_LIST = 'special-project/ux/division',
    SPECIAL_PROJECT_DISTRICT_LIST = 'special-project/ux/district',
    SPECIAL_PROJECT_BRANCH_LIST = 'special-project/ux/branch',
    SPECIAL_PROJECT_TECHNITIAN_LIST = 'ux/technician/search',
    SPECIAL_PROEJCT_TECHNICIAN_DETAILS = 'special-project-technician-details',
    SPECIAL_PROEJCT_COORDINATOR_LIST = 'special-project-technical-coordinator',
    SPECIAL_PROEJCT_COORDINATOR_DETAILS = 'special-project-technical-coordinator-allocation-details',
    SPECIAL_PROEJCT_EXCLUDE_FILE_DOWNLOAD = 'special-project-exclude-customer-download',
    SPECIAL_PROEJCT_VALIDATION = 'special-project/validation',
    TECHNICAL_TESTING_CONFIG = 'technical-testing-config',

    BILL_OF_MATERIAL_SERVICE_CALL_DISCOUNT = 'bill-of-material/technical-service-call-discount',
    BILL_OF_MATERIAL_SERVICE_CALL_DISCOUNT_APPROVE = 'bill-of-material/technical-service-call-discount/approval',

    VIDEOFIED_CONFIG = 'videofied-config',
    VIDEOFIED_CONFIG_DELETE = 'videofied-config-delete',
    VIDEOFIED_SIM_REQUEST_CONFIG_DETAILS = 'videofied-simrequest-config-details',
    VIDEOFIED_SIM_REQUEST_CONFIG = 'videofied-simrequest-config',
    VIDEOFIED_SIM_REQUEST_CONFIG_DELETE = 'videofied-simrequest-config-delete',
    VIDEOFIED_CONFIG_ITEM = 'ux/videofied-config-item',

    CUST_SATISFACTION_CONFIG_DETAILS = 'customer-satisfaction-config-details',
    CUST_SATISFACTION_CONFIG__SUBMIT = 'customer-satisfaction-config',
    RATING_ITEM_CONFIG_DETAILS = 'rating-item-config-details',
    RATING_ITEM_TYPE = 'ux/rating-type',
    RATING_ITEM_CALL_TYPE = 'ux/technician-call-type',
    RATING_ITEM_CONFIG_SUBMIT = 'rating-item-config',
    INSPECTION_CONFIG_LIST = 'inspection-iteminspected-config-List',
    INSPECTION_CONFIG_POST = 'inspection-iteminspected-Config',
    INSPECTION_CONFIG_DELETE = 'inspection-iteminspected-Config-delete',
    SIGNALS_CONFIG_LIST = 'inspection-signal-tested-config-details',
    SIGNALS_CONFIG_DETAILS = 'inspection-signal-tested-config',
    CONTACTS_DROPDOWN_CONFIG_DETAILS = 'rate-our-service-contact-config',
    CALLS_TO_INCLUDE_STATUS_TYPE = 'ux/call-status-type',
    UX_COURTESY_CALL_CONFIG_CALL_STATUS = 'ux/courtesy-call-config/call-status',
    CALLS_TO_INCLUDE_CONFIG_DETAILS = 'courtesy-call-config-details',
    CALLS_TO_INCLUDE_CONFIG_SUBMIT = 'courtesy-call-config',
    CUSTOMER_TECH_APP_RATING_CONFIG_DETAILS = 'customer-tech-app-rating-config',


    SIGNALS_CONFIG_POST = 'inspection-signal-tested-config',
    STATUS_CONFIG_LIST = 'inspection-status-config',
    STATUS_CONFIG_DELETE = 'inspection-status-config-delete',
    SIGNOFF_CONFIG_LIST = 'inspection-signoff-config',
    SIGNOFF_CONFIG_DELETE = 'InspectionSignOffConfig-delete',
    CONTACTS_CONFIG_LIST = 'inspection-contact-config-details',
    CONTACTS_CONFIG_POST = 'inspection-contact-config',
    CONTACTS_CONFIG_DELETE = 'inspection-contact-config-delete',
    SEVERITY_RATING_LIST = 'inspection-severity-rating-config',
    SEVERITY_RATING_DELETE = 'inspection-severity-rating-config-delete',
    FEEDBACK_LIST = 'inspection-feedback-config',
    FEEDBACK_DELETE = 'inspection-feedback-config-delete',

    BILL_OF_MATERIAL_WARRANTY_CHECK = 'bill-of-material/warranty-check',
    UX_DEALER_CALL_FEEDBACK_TYPES = 'ux/dealerCallFeedbackTypes',
    DEALER_CALL_FEEDBACK_CONFIG = 'dealer-call-feedback-config',
    DEALER_CALL_FEEDBACK_CONFIG_DELETE = 'dealer-call-feedback-config-delete',
    INCENTIVE_CALCULATION_DATE_CONFIG_DETAILS = 'incentive-calculation-date-config-details',
    INCENTIVE_CALCULATION_DATE_CONFIG_POST = 'incentive-calculation-date-config',
    INCENTIVE_TYPE_CONFIG_DETAILS = 'incentive-type-config-details',
    INCENTIVE_CONFIG_BULK_DETAILS = 'incentive-config-bulk-details',
    INCENTIVE_CONFIG_BULK_UPDATE = 'incentive-config-bulk-update',
    INCENTIVE_TYPE_CONFIG = 'ux/incentive-type-config',
    INCENTIVE_TYPE_CONFIG_POST = 'incentive-type-config',
    INCENTIVE_CONFIG_DETAILS = 'incentive-config-details',
    INCENTIVE_CONFIG_POST = 'incentive-config',
    SPECIAL_PROJECT_CONFIG_LIST = 'incentive-special-project-config',
    SPECIAL_PROJECT_CONFIG_DETAILS = 'incentive-special-project-config-jobtype',
    SPECIAL_PROJECT_CONFIG_POST = 'incentive-special-project-config',
    STANDBY_ALLOWANCE_CONFIG_LIST = 'incentive-standby-allowance-config',
    STANDBY_ALLOWANCE_CONFIG_DETAILS = 'incentive-standby-allowance-config-details',
    STANDBY_ALLOWANCE_CONFIG_DELETE = 'incentive-standby-allowance-config-delete',
    LEAVE_PAY_CONFIG_LIST = 'incentive-leave-pay-config',
    LEAVE_PAY_CONFIG_DETAILS = 'incentive-leave-pay-config/details',
    LEAVE_PAY_CONFIG_DELETE = 'incentive-leave-pay-config-delete',
    SUB_CONTRACTOR_CONFIG_LIST = 'incentive-sub-contractor-config',
    SUB_CONTRACTOR_CONFIG_DETAILS = 'incentive-sub-contractor-config-details',
    INCENTIVE_INTERIM_TYPE_LIST = 'ux/IncentiveInterimType',
    INCENTIVE_INTERIM_CONFIG_LIST = 'incentive-interim-config-List',
    INCENTIVE_INTERIM_CONFIG_DETAILS = 'incentive-interim-config-details',
    INCENTIVE_INTERIM_CONFIG_POST = 'incentive-interim-config',
    CAPACITY_CALCULATION_CONFIG = 'capacity-calculation-config',
    ALLOCATION_CAPACITY_CONFIG_LIST = 'allocation-capacity-config-list',
    ALLOCATION_CAPACITY_CONFIG = 'allocation-capacity-config',
    APPOINTMENT_TIMING_CONFIG_LIST = 'appointment-timing-config-list',
    APPOINTMENT_TIMING_CONFIG = 'appointment-timing-config',
    ADVANCED_BOOKING_CONFIG_LIST = 'advanced-booking-config-list',
    ADVANCED_BOOKING_CONFIG = 'advanced-booking-config',
    UX_MONTHS = 'ux/months',
    CAPACITY_ALLOCATION_CONFIG = 'allocation-capacity-config',
    UX_FREQUENCY = 'recurring-appointment/ux/frequency',
    RECURRING_APPOINTMENT = 'recurring-appointment',

    INSPECTION_INHOUSE_LIST = 'inspection-inhouse',
    INSPECTION_DEALERS = 'inspection-dealers',
    INSPECTION_CUSTOMER_DETAILS = 'inspection-customer',
    UX_CUSTOMR_KEYHOLDERS_WITH_CUSTOMER_ID = 'ux/customer-keyholders',
    INSPECTION_CALL_TYPES = 'ux/inspection-call-types',
    INSPECTION_FEEDBACK_TYPES = 'ux/inspection-feedback-config',
    INSPECTION_CALL_SUBMIT = 'inspection',

    INSPECTION_FORM_DETAILS = 'inspection-form',
    INSPECTION_CATEGORY = 'ux/customer-type',
    INSPECTION_STATUS = 'ux/inspection-status-config',
    INSPECTION_FORM_OB_NUMBER = 'ux/inspection-form-obnumber',
    INSPECTION_APPROVAL_STATUS = 'ux/inspection-status',
    INSPECTION_APPROVAL_SUBMIT = 'inspection-form-approval',
    INSPECTION_VALIDATION = 'inspection-validation',
    INSPECTION_ESCALATION = 'inspection-escalation',
    INSPECTION_ESCALATION_APPROVAL = 'inspection-escalation-approval',
    INSPECTION_NOTIFICATION = 'inspection-notification',
    INSPECTION_UX_SKILL_MATRIX_CONFIG_JOBTYPE = 'ux/inspection-skill-matrix-config-jobtype',
    INSPECTION_APPOINTMENT_NEXT_AVAILABLE = 'inspection-appointment-next-available',

    UX_SPECIAL_PROJECT = 'ux/special-project',
    THIRD_PARTY_SUBCONTRACTOR_FOLLOWUP = 'third-party-sub-contractor-followup',
    THIRD_PARTY_SUBCONTRACTOR_FOLLOWUP_SMS = 'third-party-sub-contractor-followup-sms',
    THIRD_PARTY_SUBCONTRACTOR_JOBCARD = 'third-party-sub-contractor-jobcard',
    INCENTIVE_PAY_TYPES = 'ux/incentive-special-project-config/IncentivePayTypes',
    TECH_DISCOUNTING_CODES = 'tech-discounting-codes',
    TECH_DISCOUNTING_CODES_DELETE = 'tech-discounting-codes-delete',
    UX_ITEMS_DISCOUNT = 'ux/items/discount',
    UX_TECH_DISCOUNTING_CODES_TECHDISCOUNTINGPROCESS = 'ux/tech-discounting-codes/TechDiscountingProcess',
    INSPECTION_CALL_BACK = 'inspection-callback',
    INSPECTION_CANCEL = 'inspection-cancel',
    VIDEOFIED_INFO = 'videofied-info',
    VIDEOFIED_INFO_DETAILS = 'videofied-info/details',
    CUSTOMER_INSPECTION_NO_CONTACTS = 'customer-inspection-no-contacts',
    ALARM_USER_CONFIG = 'alarm-user-config',
    ALARM_USER_CONFIG_DELETE = 'alarm-user-config-delete',
    RATE_OUR_SERVICE_CALL = 'rate-our-service-call',

    RESIDENTIAL_CALL_OUT_FEE_PRICING = 'residential-call-out-fee-pricing',
    TECHNICAL_CALLOUT_COMMERCIAL = 'technical-callout-commercial',
    TECHNICAL_CALLOUT_COMMERCIAL_LIST = 'technical-callout-commercial-List',
    TECHNICAL_CALLOUT_COMMERCIAL_DELETE = 'technical-callout-commercial-delete',
    TECHNICAL_CALLOUT_RESIDENTIAL_DELETE = 'residential-call-out-fee-pricing-delete',
    TECHNICAL_CALL_OUT_COMMERCIAL_DETAILS = 'technical-callout-commercial-details',

    EMOJI_CONFIG_LIST = 'emoji-config',
    EMOJI_CONFIG_DETAILS = 'emoji-config-details',
    INSPECTION_SNOOZE_TIME = 'ux/inspection-callback-snooze-mins',
    INSPECTION_SNOOZE_SUBMIT = 'inspection-callback-snooze',
    REBOOK_SNOOZE_TIME = 'ux/callinitiation-rebook-snooze-mins',
    REBOOK_SNOOZE_SUBMIT = 'callinitiation-rebook-snooze',
    ADVANCE_CUSTOMER_SEARCH = 'advance-customer-search',
    TECHNICIAN_INCENTIVE = 'technician-incentive',
    TECHNICIAN_INCENTIVE_APPROVAL_LIST = 'technician-incentive-approval-list',
    UX_TECH_INCENTIVE_STATUS = 'ux/tech-incentive-status',
    TECHNICIAN_INCENTIVE_APPROVAL = 'technician-incentive-approval',
    TECHNICIAN_STAFF_REGISTRATION_INCENTIVE_APPROVAL_SCHEME_TYPE = 'ux/technician-staff-registration/Incentive-scheme',
    TECHNICIAN_STAFF_REGISTRATION_INCENTIVE_SCHEME_TYPE = 'ux/incentive-type-config',
    TECHNICIAN_STAFF_REGISTRATION_INCENTIVE_SUBMIT = 'technician-staff-registration/IncetiveScheme',
    TECHNICIAN_STAFF_REGISTRATION_INCENTIVE_APPROVAL_DETAILS = 'technician-staff-registration/Incentive-scheme-details',
    TECHNICIAN_STAFF_REGISTRATION_INCENTIVE_APPROVAL_SUBMIT = 'technician-staff-registration/Incentive-scheme-approval',
    BILL_OF_MATERIAL_REMOVE_VALIDATION = 'bill-of-material/stockitem-remove-validation',
    VIDEOFIED_INFO_REQUEST = 'videofied-info-request',
    VIDEOFIED_INFO_REQUEST_STATUS = 'ux/videofied-info-request-status',
    VIDEOFIED_INFO_FOLLOWUP = 'videofied-info-followup',
    TECHNICIAN_INCENTIVE_REVENUE = 'technician-incentive-revenue',
    VIDEOFIED_INFO_FOLLOWUP_STATUS = 'ux/videofied-info-followup-status',
    TAM_ESCALATION_DETEAILS = 'appointments/tam-escalation-details',
    TAM_APPOINTMENTS = 'appointments-tam',
    BILL_OF_MATERIAL_STOCK_KIT_DETAILS = 'bill-of-material/stock-kit-details',
    UX_CALL_INITIATION_LOCATION = 'call-initiation-location',
    INSPECTION_LOCATION = 'inspection-location',
    DISPATCHING_USER_LOCATION = 'dispatching-user-location',
    TECHALLOCATION_CAPACITY = 'appointments-validate-techallocation-capacity',
    TECHALLOCATION_TECHNICIAN_AVAILABILITY = 'appointments-validate-technician-availability',
    INSPECTOR_AVAILABILITY = 'inspection-validate-inspector-availability',
    APPOINTMENTS_VALIDATE_ADVANCE_BOOKING = 'appointments-validate-advance-booking',
    APPOINTMENTS_LOGS_PROVISONAL_BOOKING = 'appointments-logs',
    UX_TECHNICIAN_TECH_AREA = 'ux/technician-tech-area',
    TECHNICIAN_INCENTIVE_LIST_EXPORT = 'technician-incentive-list/export',
    TECHNICIAN_INCENTIVE_APPROVAL_LIST_EXPORT = 'technician-incentive-approval-list/export',
    BILL_OF_MATERIAL_INVOICE_VALIDATION = 'bill-of-material/invoice-validation',
    BILL_OF_MATERIAL_WARRANTY = 'bill-of-material/warranty',
    TECHNICIAN_INCENTIVE_EMAIL = 'technician-incentive/email',

    BILL_OF_MATERIAL_JOB_CARD_ACCEPTANCE = 'job-card-acceptance',
    BILL_OF_MATERIAL_SEND_JOB_CARD_APPROVAL = 'send-job-card-approval',
    BILL_OF_MATERIAL_GET_JOB_CARD_DETAILS = 'jobcard-detail',
    BILL_OF_MATERIAL_SEND_JOB_CARD_APPROVAL_ACCEPT = 'jobcard-accept',
    BILL_OF_MATERIAL_SEND_JOB_CARD_APPROVAL_DECLINE = 'jobcard-decline',
    BILL_OF_MATERIAL_SEND_JOB_CARD_APPROVAL_CALLMEBACK = 'jobcard-callback',

    NO_SIGNAL_REQUEST_STATUS = 'ux/no-signals-request-status',
    NO_SIGNAL_REQUEST = 'no-signals',
    BILL_OF_MATERIAL_SEARCH_STOCK_DETAILS = 'ux/bill-of-material-items',
    TECHNICIAN_STAFF_REGISTRATION_INCENTIVE_PROCESS = 'technician-incentive-process',

    BILL_OF_MATERIAL_JOB_CARD_ACCEPTANCE_PROCESS_INVOICE = 'job-card-acceptance/process-invoice',
    BILL_OF_MATERIAL_JOB_CARD_ACCEPTANCE_PAYMENT_PROCESS_DETAILS = 'job-card-acceptance/process-payment-detail',
    BILL_OF_MATERIAL_JOB_CARD_ACCEPTANCE_PAYMENT_PROCESS = 'job-card-acceptance/service-call/process-payment',

    TECHNICIAN_STOCK_TAKE_INITIATION = 'TechnicianStockTakeInitiation',
    TECHNICIAN_STOCK_TAKE_INITIATION_CANCEL = 'TechnicianStockTakeInitiation-cancel',
    TECH_STOCKTAKE_TIME_ALLOCATIONS = 'Tech-stocktake-time-allocations',
    UX_COORDINATOR = 'ux/coordinator',
    APPOINTMENTS_ACTUAL_TIMING_DATES = 'ux/appointments-logs',
    TECHNICIAN_SIGNAL_MANAGEMENT_DETAILS = 'technician-signal-management/details',
    TECHNICIAN_STAFF_REGISTRATION_TECHTESTINGMOBILE_VALIDATOR = 'technician-staff-registration/techtestingmobile-validator',
    GEOLOCATION_VARIANCE_CONFIG = 'geolocation-variance-config',
    UX_STANDBY_ROSTER_USER_TYPES = 'ux/standby-roster-user-types',
    INTTECH_TRANSFER_DETAILS = 'inttech-transfer-details',
    CUSTOMER_ORDER_INTTECH_TRANSFER_DETAILS = 'customer-order/inttech-transfer-details',
    UX_STOCKORDERS_REQUISITION = 'ux/stockorders-Requisition',
    INTTECH_TRANSFER_APPROVE = 'inttech-transfer-approve',
    TECHNICIAN_STOCK_TAKE_REPORT = 'TechnicianStockTake-report',
    TECHNICIAN_STOCK_TAKE   = 'TechnicianStockTake',
    WORK_SUMMARY_TECHNICIAN = 'technician-signal-management-worksummary',
    WORK_SUMMARY_TECHNICIAN_DETAIL = 'technician-signal-management-work-detail',
    SERVICE_CALL_INITIATION_SIGNAL_MANAGEMENT = 'service-call-initiation/signal-management',
    BILL_OF_MATERIAL_SEARCH_SERIAL_NUMBER = 'bill-of-material/validate-serialnumber',
    CALL_CREATION_PAYMENT = 'Call-Creation-Payment',
    CALL_CREATION_PAYMENT_DELETE = 'Call-Creation-Payment-delete',
    TECHNICIAN_STAFF_REGISTRATION_TECHNICIANAREA_CHANGE_VALIDATE = 'technician-staff-registration/techniciantechArea-change-validate',
    TECH_STOCK_TAKE_INVESTIGATION = 'tech-stock-take-investigation',
    UX_TECH_STOCK_TAKE_INVESTIGATION_STATUS = 'ux/tech-stock-take-investigation-status',
    UX_TECH_STOCK_TAKE_INVESTIGATION_ACTION = 'ux/tech-stock-take-investigation-action',
    UX_TECH_STOCK_TAKE_INVESTIGATION_SWAP = 'ux/tech-stock-take-investigation-swap',
    TECH_STOCK_TAKE_INVESTIGATION_STOCK_SWAP = 'tech-stock-take-investigation-stock-swap',
    GOODS_RETURN = 'goods-Return',
    UX_CALL_CREATION_PAYMENT = 'ux/Call-Creation-Payment',
    MONTHLY_DAYS = 'ux/monthly-days',
    BILL_OF_MATERIAL_GOODS_RETURN_DETAILS = 'goods-Return-details',
    TECHNICIAN_STAFF_REGISTRATION_PSIRAREGNO_VALIDATE = 'technician-staff-registration/psiraregno-validate',
    CUSTOMER_ORDER_INTTECH_TRANSFER_APPROVE = 'customer-order/inttech-transfer-approve',
    TECHNICIAN_STOCK_TAKE_DOAPPROVAL = 'TechnicianStockTake-doapproval',
    SPECIAL_PROJECT_BRANCH_TECHNICIAN_LIST = 'ux/branch-technician',
    SPECIAL_PROJECT_TECH_AREA_TECHNICAL_COORDINATOR_LIST = 'ux/special-project-technical-coordinator',
    SKILL_MATRIX_CONFIG_LIST_EXPORT = 'skill-matrix-config-list/export',
    UX_AOD = 'ux/aod',
    UX_BRANCH_TECHNICIAN = 'ux/branch-technician',

    BILL_OF_MATERIAL_SEARCH_STOCK_DETAILS_TECHNICIAN = 'ux/bill-of-material-tech-items',
    TECH_STOCK_TAKE_VARIANCE_REPORT_DETAILS = 'tech-stock-take-variance-report-details',
    TECH_STOCK_TAKE_VARIANCE_REPORT_STOCK_SWAP = 'tech-stock-take-variance-report-stock-swap',
    TECH_STOCK_TAKE_VARIANCE_REPORT_GOODS_RETURNS = 'tech-stock-take-variance-report-goods-returns',
    TECH_STOCK_TAKE_VARIANCE_REPORT_SERVICE_CALL = 'tech-stock-take-variance-report-service-call',

    INSPECTION_APPOINTMENT_NEXT_AVAILABLE_DATE = 'inspection-appointment-slots',
    TECH_STOCK_TAKE_VARIANCE_REPORT_AOD = 'tech-stock-take-variance-report-aod',

    TECH_STOCK_TAKE_VARIANCE_REPORT_PAYROLL = 'tech-stock-take-variance-report-payroll',
    UX_TECH_STOCK_TAKE_VARIANCE_REPORT_ACTION = 'ux/tech-stock-take-variance-report-action',
    TECH_STOCK_TAKE_VARIANCE_REPORT_PAYROLL_APPROVAL = 'tech-stock-take-variance-report-payroll-approval',

    UX_STOCK_MAINTENANCE_ITEM_SELLALE_TYPES = 'ux/stock-maintenance-item-sellable-types',
    TECH_STOCK_TAKE_VARIACE_REPORT_AOD_FORM = 'tech-stock-take-variance-report-aod-form',

    STANDBY_ROSTER_CUSTOMER_VIEW_DETAILS = 'standby-roster-customer-view-details',
    UX_CHAT_FILE_SIZE = 'ux/chat-file-size',
    CHAT_FILE_SIZE_CONFIG = 'chat-file-size-config',

    TECH_STOCK_TAKE_VARIANCE_REPORT_AOD_APPROVAL = 'tech-stock-take-variance-report-aod-approval',

    LIGHTNING_COVER_LINK_CONFIG = 'lighting-cover-link-config',
    LIGHTNING_COVER_LINK_TYPES = 'ux/lighting-cover-link-types',
    BILL_OF_MATERIAL_TECHNICAL_INVOICE_REQUEST = 'bill-of-material/technical-invoice-dispute-request',
    BILL_OF_MATERIAL_TECHNICAL_INVOICE_REQUEST_URL = 'bill-of-material/technical-invoice-dispute-request-url',

    DEALER_CALL = 'dealer-call',
    DEALER_CALL_CUSTOMER = 'dealer-call-customer',

    GOODS_RETURN_VIEW = 'goods-Return-view',
    GOODS_RETURN_ITEM_SCAN = 'goods-Return-item-scan',
    SIGNAL_HISTORY_TECH_TABLET_CONFIG = 'signal-history-tech-tablet-config',
    APPOINTMENT_BOOKING_TIME_SLOTS = 'appointment-booking-time-slots',
    DIAGNOSIS = 'diagnosis',
    DIAGNOSIS_DETAILS = 'diagnosis-details',
    UX_TECHNICIAN_PROCESS = 'ux/technician-process',
    UX_DIAGNOSIS_INVOICE_TOTAL_AMOUNT_TYPES = 'ux/diagnosis-invoice-total-amount-types',
    UX_DIAGNOSIS_INSPECTION_RESULT_STATUS = 'ux/diagnosis-inspection-result-status',
    WORK_LIST_WIREMAN = 'work-list-wireman',
    UX_INSPECTION_STREETNAMES = 'ux/inspection-streetnames',
    TECH_STOCK_LIMIT_CONFIG = 'tech-stock-limit-config',
    TECH_STOCK_LIMIT_CONFIG_DETAILS = 'tech-stock-limit-config-details',
    UX_DEALER_CALL_FEEDBACK_CONFIG = 'ux/dealer-call-feedback-config',
    TECH_AUDIT_CYCLE_ALLOCATION_CONFIG = 'tech-audit-cycle-allocation-config',
    TECH_AUDIT_CYCLE_ALLOCATION_CONFIG_DETAILS = 'tech-audit-cycle-allocation-config-details',
    TECH_AUDIT_CYCLE_ALLOCATION_CONFIG_VALIDATE = 'tech-audit-cycle-allocation-config/Validate',
    RADIO_REMOVAL_CALL_VALIDATION = 'radio-removal-call-validation',
    CUSTOMER_ADDRESS_CONFIRMATION_CONFIG = "customer-address-confirmation-config",
    CUSTOMER_ADDRESS_CONFIRMATION_REQUEST_DETAILS = 'customer-address-confirmation-request-details',
    CUSTOMER_ADDRESS_CONFIRMATION_REQUEST_APPROVAL = 'customer-address-confirmation-request-approval',

    GOODS_RETURN_CONSUMBALE = 'goods-return-consumable',
    GOODS_RETURN_NON_CONSUMABLE = 'goods-return-non-consumable',
    RADIO_REMOVAL_CALL = 'radio-removal-call',
    RADIO_REMOVAL_CALL_CUSTOMER = 'radio-removal-call-customer',
    RADIO_REMOVAL_CALL_ESCALATION = 'radio-removal-call-escalation',
    RADIO_REMOVAL_CALL_ESCALATION_APPROVAL = 'radio-removal-call-escalation-approval',

    TECH_AUDIT_CYCLE_COUNT = 'TechAuditCycleCount',
    TECH_AUDIT_CYCLE_COUNT_STOCK_DETAILS = 'TechAuditCycleCount-StockDetails',
    TECHNICIAL_TERMS_AND_CONDITIONS = 'technicial-terms-and-conditions',
    TECHNICIAL_TERMS_AND_CONDITIONS_DOCUMENT_UPLOAD = 'technicial-terms-and-conditions/document-upload',
    TECH_TRANSFER_STOCK_RETURN = 'tech-transfer/stock-return',
    CUSTOMER_SELF_HELP_QUESTION_ANSWER = 'customer/self-help-question-answer',
    TECH_AUDIT_CYCLE_JOB_REPORT = 'TechAuditCycleCountJob-Report',
    TECH_AUDIT_CYCLE_COUNT_JOB_PROGRESS = 'TechAuditCycleCountJob-progress',
    UX_DIAGNOSIS_TECHNICIAN_PROCESS_TYPES = 'ux/diagnosis-technician-process-types',
    CALL_INITIATION_GRV_NOTIFICATION = 'call-initiation-grv-notification',
    RADIO_CUSTOMER_GEO_VARIANCE = 'radio-customer-geo-variance',
    RADIO_CUSTOMER_GEO_VARIANCE_APPROVE = 'radio-customer-geo-variance-approve',

    TECH_STOCK_TAKE_INVESTIGATION_SERVICE_CALL = 'tech-stock-take-investigation-service-call',
    SERVICE_CALL_INITIATION_NOTES = 'service-call-initiation-notes',
    TECHNICIAN_STAFF_REGISTRATION_PSIRA_REQUEST_DETAILS = 'technician-staff-registration/PSIRARequest-details',
    TECHNICIAN_STAFF_REGISTRATION_PSIRA_REQUEST_APPROVE = 'technician-staff-registration/PSIRARequest-Approve',
    TECHNICIAN_INCENTIVE_DETAIL = 'technician-incentive-details',
    CALL_INITIATION_DIAGNOSIS_UPDATE = 'call-initiation-diagnosis-update',
    HANDLING_FEE_CONFIG = 'handling-fee-config',
    HANDLING_FEE_CONFIG_DETAILS = 'handling-fee-config-details',
    TECHNICIAN_INCENTIVE_INCLUDE_EXCLUDE = 'technician-incentive-include-exclude',
    DEALER_BILL_OF_MATERIAL_VALIDATE_SERIAL_NUMBER = 'dealer-bill-of-material/validate-serialnumber',
    CALL_INITIATION_ON_HOLD_APPROVAL = 'call-initiation-on-hold-approval',
    EXECGUARD_SERVICE_CALL_OWNERSHIP_UPDATE = 'execuguard-service-call-ownership-update',
    CREDIT_CONTROLLER_NOTIFICATION = 'credit-controller-notification',
    INCENTIVE_STANDBY_ALLOWANCE_CONFIG_BULK_DETAILS = 'incentive-standby-allowance-config-bulk-details',
    INCENTIVE_STANDBY_ALLOWANCE_CONFIG_BULK_UPDATE = 'incentive-standby-allowance-config-bulk-update',
    INCENTIVE_LEAVE_PAY_CONFIG_BULK_DETAILS = 'incentive-leave-pay-config-bulk-details',
    INCENTIVE_LEAVE_PAY_CONFIG_BULK_UPDATE = 'incentive-leave-pay-config-bulk-update',
    INCENTIVE_SUB_CONTRACTOR_CONFIG_BULK_DETAILS = 'incentive-sub-contractor-config-bulk-details',
    INCENTIVE_SUB_CONTRACTOR_CONFIG_BULK_UPDATE = 'incentive-sub-contractor-config-bulk-update',
    SERVICE_CALL_INITIATION_EXISTING_CALL = 'service-call-initiation-existing-call',
    APPOINTMENTS_VALIDATION = 'appointments-validation',
    BILL_OF_MATERIAL_SERIALNUMBER = 'bill-of-material-serialnumber',
    UX_CALL_INTIATION_DECODER = 'ux/call-initiation-decoder',
    BILL_OF_MATERIAL_VADATE_DECODERS = "bill-of-material/validate-decoders",
    CONSUMABLE_CONFIGURATION_EXPORT = "consumable-configuration-export",
    TECHNICIAN_STAFF_REGISTRATION_DETAIL_LOG = 'technician-staff-registration/detail-log',
    PR_CALL_ITEMS = 'pr-call-items',
    SAVE_OFFER_ITEMS = 'save-offer-items',
    UX_CALL_INITIATION = 'ux/call-initiation',
    UX_RTR_CALL_INITIATION = 'ux/rtr-request/call-initiation',
    UX_NKA_SERVICE_CALL_OWNERSHIP = 'ux/nka-service-call-ownership',
    UX_NKA_SERVICE_CALL_POSTATUS = 'ux/nka-service-call-postatus',
    UX_NKA_SERVICE_CALL_PONUMBER = 'ux/nka-service-call-ponumber',
    UX_CALL_INITIATION_USERS = 'ux/call-initiation-users',
    UX_EXECUGUARD_SERVICE_CALL_OWNERSHIP = 'ux/execuguard-service-call-ownership',
    UX_EXECUGUARD_SERVICE_CALL_ACTION_STATUS = 'ux/execuguard-service-call-action-status',
    CALL_INITIATION_ON_HOLD_FOLLOWUP = 'call-initiation-on-hold-followup',
    CALL_INITIATION_JOBCARD = 'call-initiation-jobcard',
    UX_APPOINTMENT_RESCHEDULE_REASON = 'ux/appointments-reschedule-reason',
    CONSUMABLE_CONFIGURATION_DETAILS = 'consumable-configuration-details',
    CONSUMABLE_CONFIGURATION_EXCLUDE_TECHNICIAN = 'consumable-configuration-exclude-technician',
    JOB_CARD_ACCEPTANCE_VALIDATION = 'job-card-acceptance-validation',
    TECHNICIAN_STAFF_REGISTRATION_TERMINATION_DETAIL = 'technician-staff-registration/termination-detail',
    TECHNICIAN_STAFF_REGISTRATION_TERMINATION_STOCK_BIN_DETAIL = 'technician-staff-registration/termination-stock-bin-detail',
    CHAT_GROUP_VALIDATE = 'chat-group-validate',
    UX_CALL_INITIATION_HOUSEKEEPING_CANCEL_STATUS = 'ux/call-initiation-housekeeping-cancel-status',
    CALL_INITIATION_HOUSEKEEPING_CANCEL_REQUEST = 'call-initiation-housekeeping-cancel-request',
    CALL_INITIATION_VOID_CALL_REPORT = 'call-initiation-void-call-report',
    CALL_INITIATION_AUDIT_LOG = 'call-initiation-audit-log',
    DIPATCHING_ACKNOWLEDGE = 'dispatching-acknowledge',
    INSPECTION_CALLER_FLAG = 'inspection-caller-flag',
    TECHNICIAN_STAFF_REGISTRATION_USERTYPE_VALIDATE = 'technician-staff-registration/usertype-validate',
    TECHNICIAN_STAFF_REGISTRATION_TECHAREA_CHANGE_REQUEST = 'technician-staff-registration/techarea-change-request',
    CALL_INITIATION_AUTO_INVOICED_CALLS = 'call-initiation-auto-invoiced-calls',
    UX_RADIO_RECURRING_FEES_PATH='ux/radio-recurring-fees/path',
    RADIO_RECURRING_FEES='radio-recurring-fees',
    TECHNICAL_WORK_LIST_EXPORT = 'technical-work-list-export',
    UX_TECHNICAL_WORK_LIST_REQUEST_TYPE = 'ux/technical-work-list-request-types',
    UX_TECHNICAL_WORK_LIST_REQUESTOR = 'ux/technical-work-list-requestor',
    UX_TECHNICAL_WORK_LIST_CUSTOMERS = 'ux/technical-work-list-customers',
    UX_TECHNICAL_WORK_LIST_REQUEST_NUMBER = 'ux/technical-work-list-request-number',
    UX_RADIO_RECURRING_FEES='ux/radio-recurring-fees',
    GET_DISPATCHER_TECHNICIAN='dispatching-map',
    GET_DISPATCHER_MAP_LEGEND='dispatching-map-legend',
    DISPATCHER_MAP_TECHNICIAN_DETAILS='dispatching-map-technician-details',
    FILTER_BY_DISPATCHER_LOCATION='ux/dispatching-user-location',
    BILL_OF_MATERIAL_VADATE_NOTSERIALIZED = 'bill-of-material/validate-notserialized',
    NKA_SERVICE_CALL_PURCHASE_ORDER = 'nka-service-call/purchase-order',
    NKA_SERVICE_CALL_PURCHASE_ORDER_APPROVAL = 'nka-service-call/purchase-order/approval',
    SERVICE_CALL_INITIATION_CONTACT_DETAILS = 'service-call-initiation-contact-details',
    UX_TECH_STOCKTAKE_STATUS = 'ux/tech-stocktake-status',
    TECHNICEAN_TESTING_PASSWORD_VERIFICATION = 'technician-staff-registration/password-validate',
    INSPECTION_EMAIL_TEMPLATE = 'inspection-email-template',
    UX_DISPATCHING_UNSCHEDULED_CALLS='ux/dispatching-unschedule-call',
    TECHNICAL_COORDINATOR_SIGNAL_MANAGEMENT_WORKSUMMARY = 'technical-coordinator-signal-management-worksummary',
    STOCK_SWAP_REQUEST_ITEMS = 'stock-swap-request-items',
    STOCK_SWAP_REPLACE_ITEMS = 'stock-swap-replace-items',
    TECHNICIAN_STAFF_REGISTRATION_TECHTESTING_PASSWORD = 'technician-staff-registration/techtesting-password',
    TECHNICIAN_STAFF_REGISTRATION_PANICDURESS_PASSWORD = 'technician-staff-registration/panicduress-password',
    VIDEOFIED_INFO_PASSWORDS = 'videofied-info/passwords',
    CALL_INITIATION_REFER_TO_SALES_VALIDATION = 'call-initiation-refer-to-sales-validation',
    THIRD_PARTY_SUBCONTRACTOR_DOCUMENTS = 'third-party-sub-contractor-documents',
    UX_TECH_AREA_POST = 'ux/tech-area-post',
    UX_TECHNICIAN_POST = 'ux/technician-post',
    NO_SIGNAL_FOLLOWUP_ACKNOWLEDGE = 'no-signals-followup-acknowledge',
    TECHNICIAN_STOCK_TAKE_VALIDATE_QRCODE = 'TechnicianStockTake-Validate-qrcode',
    UX_CALL_INITIATION_DEBTOR = 'ux/call-initiation-debtor',
    UX_CALL_INITIATION_CUSTOMER = 'ux/call-initiation-customer',
    UX_GOODS_RETURN_CUSTOMER_ORDERS = 'ux/goods-return-customer-orders',
    UX_STOCK_ORDER_APPROVAL_ORDERS = 'ux/stock-order-approval-orders',
    UX_STOCK_ORDER_APPROVAL_STATUS = 'ux/stock-order-approval-status',

    APPOINTMENT_SAME_DAY_VALIDATION = 'appointments-sameday-validation',
    CALL_STATUS_REPORT_EXPORT = 'call-status-report-export',
}

enum TechnicalAppointmentStatus {
    NEW = 'New',
    BOOKED = 'Booked',
    PROVISIONAL_BOOKING = 'Provisional Booking'
}

enum TECHNICAL_COMPONENT {
    TECHNICAL_MANAGEMENT = "Technical Management",
    MY_TASK = "My Task",
    CALL_STATUS = "Call Status",
    DISPATCHING_DASHBOARD = "Dispatching Dashboard",
    STOCK_ORDER_APPROVAL = "Stock Order Approval",
    STOCK_ORDER_REQUEST = "Stock Order Request",
    STOCK_ORDER_HISTORY = "Stock Order History",
    CONFIGURATION = "Configuration",
    DISPATCHING = "Dispatching",
    PANEL_TYPE = "Panel Type",
    WARRANTY_PERIOD = "Warranty Period",
    CALL_CREATION_CONFIGURATION = "Call Creation Configuration",
    REFER_TO_SALES = "Refer To Sales",
    SKILL_MATRIX_CONFIGURATION = "Skill Matrix Configuration",
    CONSUMABLE_CONFIGURATION = "Consumable Configuration",
    ON_HOLD_TO_VOID_ = "On Hold to Void ",
    TECHNICAL_USER_TYPE = "Technical User Type",
    DECODER = "Decoder",
    FAULT_DESCRIPTION = "Fault Description",
    STANDBY_ROSTER_CONFIGURATION = "Standby Roster Configuration",
    LIGHTNING_COVER = "Lightning Cover",
    AUTO_INVOICING_CONFIGURATION = "Auto Invoicing Configuration",
    SCHEDULING_CUT_OFF_TIMING = "Scheduling Cut off timing",
    REBOOK = "Rebook",
    INSPECTION_SKILL_MATRIX_CONFIGURATION = "Inspection Skill Matrix Configuration",
    VIDEOFIED_CONFIGURATION = "Videofied Configuration",
    TECH_TESTING_CONFIGURATION = "Tech Testing Configuration",
    COURTESY_CALL_CONFIGURATION = "Courtesy Call Configuration",
    CUSTOMER_INSPECTION_CONFIGURATION = "Customer Inspection Configuration",
    DEALER_SERVICE_CALL_CONFIG = "Dealer Service Call Config",
    DEALER_SERVICE_CALL_FEEDBACK_CONFIG = "Dealer Service Call Feedback Config",
    CAPACITY_CONFIGURATION = "Capacity Configuration",
    INCENTIVE_CONFIGURATION = "Incentive Configuration",
    TECHNICAL_DISCOUNTING_CODES = "Technical Discounting Codes",
    TECHNICAL_CALL_OUT_PRICING_FEE = "Technical Call Out Pricing Fee",
    TECHNICIAN_STOCK_TAKE_TIME_ALLOCATIONS = "Tech Stock Take Time Allocations",
    TECHNICIAN_STOCK_TAKE_MANAGER = "Technician Stock Take Manager",
    TECH_STOCK_TAKE_INITIATION = "Tech Stock Take Initiation",
    RADIO_AND_CUSTOMER_GEOLOCATION_VARIANCE = "Radio and Customer Geolocation Variance",
    SELF_HELP_PORTAL_CONFIG = "Self Help Portal Config",
    PAYMENT_METHOD = "Payment Method",
    TASK_LIST = "Task List",
    CUSTOMER_INSPECTION = "Customer Inspection",
    STANDBY_ROSTER = "Standby Roster",
    SPECIAL_PROJECTS = "Special Projects",
    SPECIAL_PROJECT_TYPES = "Special Project Types",
    SPECIAL_PROJECT_INITIATION = "Special Project Initiation",
    PRICE_LIST = "Price List",
    INCENTIVES = "Incentives",
    RETURN_FOR_REPAIR = "Return for Repair",
    NKA_SERVICE_CALL = "NKA Service Call",
    EXECUGUARD_SERVICE_CALL = "Execuguard Service Call",
    PO_REQUEST = "PO Request",
    TECHNICIAN_AUDIT_CYCLE_ALLOCATION = 'Technician Audit Cycle Allocation',
    CUSTOMER_ADDRESS_VARIATION = 'Customer Address Variation',
    DIAGNOSIS_CONFIGURATION = 'Diagnosis Configuration',
    HANDLING_FEE_CONFIGURATION = 'Handling Fee Configuration',
    RADIO_WITH_RECURRING_FEES = 'Radio With Recurring Fees',
    SIGNAL_HISTORY_TECH_TABLET_VIEW = 'Signal History Tech Tablet View',
    VARIANCE_REPORT = 'Variance Report',
    DISPATCHER_MAP = 'Dispatcher Map',
    UPSELLING_PAYMENT_CONFIG = 'Upselling Payment Config',
    UPLOADING_TERMS_AND_CONDITIONS = 'Uploading Terms and Conditions',
    GOODS_RETURN_VOUCHER = 'Goods Return Voucher',
    AUDIT_CYCLE_COUNT_REPORT = 'Audit cycle count report',
    TECHNICIAN_AUDIT_CYCLE_COUNT = 'Technician Audit Cycle Count',
    TECHNICIAN_STOCK_LIMIT = 'Technician Stock Limit',
    CALL_CREATION_TEMPLATE = 'Call Creation Template',
    SCHEDULING_TIMING = 'Scheduling Timing',
    CUSTOMER_SATISFACTION = 'Customer Satisfaction',
    RATING_ITEMS = 'Rating Items',
    CONTACTS_DROP_DOWN_LIST = 'Contacts Drop Down List',
    CALLS_TO_INCLUDE_FOR_COURTESY_CALL = 'Calls To Include For Courtesy Call',
    CALLS_TO_INCLUDE_FOR_CUSTOMER_APP_TECHNICAL_APP_RATING = 'Calls To Include For Customer App Technical App Rating',
    CALLS_TO_INCLUDE_FOR_CUSTOMER_APPTECHNICAL_APP_RATING = 'Calls To Include For Customer App/Technical App Rating',
    EMOJI_CONFIG = 'Emoji Config',
    TROUBLESHOOTING_CONFIGURATIONS ='Troubleshooting Configurations',
    QUOTE_STOCK_CODES = 'Quote Stock Codes',
    SERVICE_CALL_JOB_TYPES = 'Service Call Job Types',
    TECHNICAL_REVENUE_LIST = 'Technical Revenue List',
    TECHNICIAN_ORDER = 'Technician Order',
    CUSTOMER_ORDER = 'Customer Order',
}

export { TechnicalAppointmentStatus, TECHNICAL_COMPONENT };

